import React from 'react';

const GlassCard = ({ children, className = '', style = {}, hoverEffect = false, ...props }) => {
    return (
        <div
            className={`glass-panel ${className}`}
            style={{
                padding: '24px',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                cursor: hoverEffect ? 'pointer' : 'default',
                ...(hoverEffect ? {
                    ':hover': { transform: 'translateY(-5px)' } // Note: inline styles don't support pseudo-classes directly in React without libraries, relying on class transition or external CSS mostly.
                    // For simplicity, we assume glass-panel handles base styles. 
                    // To add hover transform properly via inline style requires state or CSS-in-JS.
                    // We will rely on className utility or global CSS for hover logic if strictly needed, 
                    // but "glass-panel" class already handles basic look.
                    // Let's actually add a specific class for hover.
                } : {}),
                ...style
            }}
            {...props}
        >
            {children}
        </div>
    );
};

export default GlassCard;
